import { render, staticRenderFns } from "./InsectTypePicker.vue?vue&type=template&id=70fbfd28&scoped=true&"
import script from "./InsectTypePicker.vue?vue&type=script&lang=js&"
export * from "./InsectTypePicker.vue?vue&type=script&lang=js&"
import style0 from "./InsectTypePicker.vue?vue&type=style&index=0&id=70fbfd28&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fbfd28",
  null
  
)

/* custom blocks */
import block0 from "./InsectTypePicker.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70fbfd28')) {
      api.createRecord('70fbfd28', component.options)
    } else {
      api.reload('70fbfd28', component.options)
    }
    module.hot.accept("./InsectTypePicker.vue?vue&type=template&id=70fbfd28&scoped=true&", function () {
      api.rerender('70fbfd28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/InsectDetectionsEditor/DetectionsEditor/InsectTypePicker.vue"
export default component.exports